require('bootstrap');
require('packs/jquery-ui.js');

(() => {
  $("#product-dropdown").dropdown();
  $("#account-dropdown").dropdown();
  $("#locale-dropdown").dropdown();

  $("#product-dropdown").on('mouseenter', function () {
    if (!$(".product-menu").hasClass('show')) $(this).dropdown('toggle');
  })

  $("#product-dropdown").on('mouseleave', function () {
    setTimeout(() => {
      if (!$('.product-menu:hover').length && !$('#product-dropdown:hover').length) $("#product-dropdown").dropdown('toggle');
    }, 100)
  })

  $(".product-menu").on('mouseleave', function(){
    if($(".product-menu").hasClass('show')) $(this).dropdown('toggle');
  })
})()